import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Typography from "@material-ui/core/Typography";
import CallIcon from '@mui/icons-material/Call';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

export default function PositionedMenu({marketInfo}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        console.log({marketInfo})
        switch (event) {
            case 'support':
                window.location.assign('https://api.whatsapp.com/send?phone='+marketInfo.whatsapp);
                break
            case 'call':
                window.location.assign('tel:'+marketInfo.tell);
                break
            case 'telegram':
                window.location.assign('https://telegram.me/'+marketInfo.telegram);
                break
            case 'instagram':
                window.location.assign('http://instagram.com/_u/'+marketInfo.instagram);
                break
        }
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >

                <MoreVertIcon style={{ color: "black" }} />
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {
                    marketInfo.whatsapp !== "" ?
                        <MenuItem onClick={() => handleClose('support')}><Typography><WhatsAppIcon
                            style={{width: 16, height: 16}}/> پشتیبانی ({marketInfo.whatsapp})</Typography></MenuItem>
                        : ""
                }
                {

                    marketInfo.tell !== "" ?
                        <MenuItem onClick={() => handleClose('call')}><Typography><CallIcon
                            style={{width: 16, height: 16}}/> تماس ({marketInfo.tell})</Typography></MenuItem>
                        : ""
                }
                {

                    marketInfo.instagram !== "" ?
                        <MenuItem onClick={() => handleClose('instagram')}><Typography><InstagramIcon
                            style={{width: 16, height: 16}}/> اینستاگرام({marketInfo.instagram})</Typography></MenuItem>
                        : ""
                }
                {

                    marketInfo.telegram!==""?
                    <MenuItem  onClick={()=>handleClose('telegram')}><Typography><TelegramIcon style={{width:16,height:16}}/> تلگرام ({marketInfo.telegram})</Typography></MenuItem>
                    :""
                }
            </Menu>
        </div>
    );
}
